// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ea8fead8","453":"dca6b184","455":"e573dc58","977":"3de4844f"}[chunkId] + ".chunk.js";
};